import * as React from "react";
import { Switch, Route } from "react-router-dom";
import { SvcAnalysisScreen } from "./SvcAnalysisScreen";
import { SvcSessionListScreen } from "./SvcSessionsList/SvcSessionListScreen";
import { SvcAnalysisSetListScreen } from "./AnalysisSetsList/SvcAnalysisSetListScreen";

export const SvcRoot = () => {
    return (
        <Switch>
            <Route path="/Svc" exact>
                <SvcSessionListScreen />
            </Route>
            <Route path="/Svc/Analysis" exact>
                <SvcAnalysisSetListScreen />
            </Route>
            <Route path="/Svc/Analysis/:analysisSetId/:viewState" component={SvcAnalysisScreen} />
        </Switch>
    );
}
